import { Component, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/shared/utils.service';

@Component({
    selector: 'app-about-script',
    templateUrl: './about-script.component.html',
    styleUrls: ['./about-script.component.scss'],
    standalone: false
})
export class AboutScriptComponent implements OnInit {

  constructor(public utils: UtilsService) { }

  ngOnInit(): void {
    this.utils.setTitle(' About Us');
  }

}
